import * as React from 'react'
import { graphql } from 'gatsby'
import AutoLeasingPage from '../../views/autoLeasing'

const PersonalFinancePage = (props) => <AutoLeasingPage {...props} />

export default PersonalFinancePage

export const query = graphql`
  query PersonalFinanceQuery($slug: String, $locale: String) {
    header: contentfulHeader(node_locale: { eq: $locale }) {
      ...headerFragment
    }
    footer: contentfulFooter(node_locale: { eq: $locale }) {
      ...footerFragment
    }
    waitingList: contentfulCtaSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...waitingListFragment
    }
    hero: contentfulHeroSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...heroFragment
    }
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      metaDescription
      metaTag
      title
      slug
      sections: pageSection {
        ...servicesFragment
        ...featureFragment
        ... on ContentfulSectionHeading {
          id
          sectionHeadings
        }
      }
    }
  }
`
